/**
 * Production console guard.
 *
 * Silences noisy console output (`log` / `debug` / `info`) on true production
 * builds. Staging keeps everything for debugging, and `warn` / `error` are always
 * preserved so real problems still surface in prod.
 *
 * Detection:
 *   - NODE_ENV === "production"      → set by CRA on every `build*` script
 *   - REACT_APP_ENV !== "staging"    → staging build sets this; prod build does not
 *
 * Imported at the very top of src/index.js, before the app module graph loads,
 * so module-level logs are muted too.
 */
const isProduction = process.env.NODE_ENV === "production";
const isStaging = process.env.REACT_APP_ENV === "staging";

if (isProduction && !isStaging) {
    const noop = () => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
}
